import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import renderViewsState from '../../shared/render-views-state';
import Animate from '../../shared/animation';
import Filters from '../../shared/filters/main';
import Calendar from '../../shared/calendar/main';
import Currencies from '../../shared/currencies-filter';

import Switch from '../components/switch';
import Table from '../components/table/conversions/main';
import MarkAsFraudPopup from '../components/popups/mark-as-fraud';
import ChangeStatusForm from '../components/change-status-form/main';
import Search from '../../shared/search/main';

import { selectors as rootSelectors } from '../../root';

const isRocket = process.env.CPA_ENV === 'rocket';

const Main = renderViewsState(props => (
	<Animate>
		<div className="container__content conversions">
			<div className="container__content-title">
				<div className="container__content-title-position border-hide">
					<h2 className="title">{props.intl('Statistics')}</h2>
				</div>
				<Switch {...props}/>
			</div>
			<div className="container__content-body">
				<div className="conversions__filter-position clearfix">
					<Filters {...props} {...props.filters} />
				</div>

				<div className="ui-control-bar">
					<div className="ui-control-bar__item modify-item---search">
						<div className="ui-control-bar__item-position">
							<Search
								form="conversionsCrmIdSearchForm"
								placeholder={props.intl('Search CRM ID')}
								initialValues={props.searchCrmIdInitialValues}
								action={props.searchCrmId}
							/>
						</div>
					</div>
					<div className="ui-control-bar__item modify-item---search">
						<div className="ui-control-bar__item-position">
							<Search
								form="conversionsCpaIdSearchForm"
								placeholder={props.intl('Search CPA ID')}
								initialValues={props.searchCpaIdInitialValues}
								action={props.searchCpaId}
							/>
						</div>
					</div>
					<div className="ui-control-bar__item">
						<div className="ui-control-bar__item-position">
							{ props.can('mark_as_fraud') &&
								<button
									className="ui-btn ui-btn-primary"
									disabled={!props.affiliatesFilterValues.length}
									onClick={async () => {
										await props.apply();
										await props.initFraudPopup();
									}}
								>
									{props.intl('Mark as Fraud')}
								</button>
							}
						</div>
					</div>
					{!isRocket && (
						<div className="ui-control-bar__item">
							<div className="ui-control-bar__item-position">
								<Currencies {...props} />
							</div>
						</div>
					)}
					<div className="ui-control-bar__item modify-item---calendar">
						<div className="ui-control-bar__item-position">
							<Calendar
								{...props.calendar}
								onInit={props.calendarInit}
								onToggle={props.calendarToggle}
								onChange={props.calendarChange}
								onApply={props.calendarApply}
								intl={props.intl}/>
						</div>
					</div>
					<div className="ui-control-bar__item">
						<div className="ui-control-bar__item-position">
							{
								props.can('analytics_view_extended_stat') &&
								<button className="ui-btn ui-btn-primary apply" onClick={props.extendedStatExport}>
									{props.intl('Extended Export')}
								</button>
							}
							{
								props.can('change_conversion_statuses') &&
								<button className="ui-btn ui-btn-primary apply" onClick={props.toggleStatusChangeForm}>
									{props.intl('Update status')}
								</button>
							}
							<button className="ui-btn ui-btn-primary apply" onClick={props.statExport}>{props.intl('Export')}</button>
							<button className="ui-btn ui-btn-primary apply" onClick={props.apply}>{props.intl('Apply')}</button>
							<button className="ui-btn ui-btn-secondary clear" onClick={props.clear} />
						</div>
					</div>
				</div>

				<div className="conversions__table-position">
					<Table
						{...props}
						isIndexing
					/>
					<MarkAsFraudPopup {...props}/>
					<ChangeStatusForm {...props}/>
				</div>
			</div>
		</div>
	</Animate>
), 'view');

export default connect(
	state => ({
		data: selectors.getData(state),
		table: selectors.getTable(state),
		calendar: selectors.getCalendar(state),
		filters: selectors.getFilters(state),
		affiliatesFilterValues: selectors.getAffiliatesFilterValues(state),
		intl: selectors.getIntl(state),
		listOfCurrencies: selectors.getListOfCurrencies(state),
		listOfRefererTypes: selectors.getListOfRefererTypes(state),
		currentCurrency: selectors.getCurrentCurrency(state),
		progressBar: selectors.getProgressBar(state),
		isFraudPopupVisible: selectors.getIsFraudPopupVisible(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		isStatusChangeFormShowed: selectors.getIsStatusChangeFormShowed(state),
		conversionCancellationReasons: selectors.getConversionCancellationReasons(state),
		conversionStatusOptions: selectors.getConversionStatusOptions(state),
		searchCrmIdInitialValues: selectors.getSearchCrmIdInitialValues(state),
		searchCpaIdInitialValues: selectors.getSearchCpaIdInitialValues(state),
		filterContextForSwitchControl: selectors.getFilterContext(state),
		can: selectors.getCan(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/statistics/conversions/main.js